module.exports = __webpack_public_path__ + "static/media/cake.33f3f2ae.png";